import {useMemo} from 'react'
import {generateBreadcrumbLinkContent} from '../blocks/breadcrumb/utils'

export const useCategoryCrumbs = ({categoryCrumbs = [], isEnabled}) => {
    const formattedCategoryCrumbs = useMemo(() => {
        if (!isEnabled || !categoryCrumbs?.length) {
            return []
        }

        const processedCrumbs = categoryCrumbs.map(({label, isClickable, category}) => {
            let categoryId = ''

            if (category?.options?.category) {
                categoryId = category.options.category
            }

            const categoryPageData = {
                model: 'page',
                value: {
                    data: {
                        url: `/${categoryId}`,
                        title: label || categoryId
                    }
                }
            }

            return generateBreadcrumbLinkContent({
                title: label,
                isClickable,
                pageData: categoryPageData
            })
        })

        return processedCrumbs
    }, [categoryCrumbs, isEnabled])

    return {categoryCrumbs: formattedCategoryCrumbs}
}
